/**
 * 강의 상세 조회 커스텀 훅
 *
 * react-query를 사용하여 강의 상세 데이터를 fetch하고 캐싱
 * - 자동 리페칭 및 캐시 관리
 * - 로딩/에러 상태 관리
 * - 챕터 및 레슨 목록 포함
 */

import { useQuery } from "@tanstack/react-query";
import { getCourseDetail } from "../api/courseApi";

/**
 * 강의 상세 조회 훅
 *
 * @param courseId - 강의 ID
 * @param options - react-query 옵션 (enabled 등)
 * @returns react-query의 useQuery 결과 (data, isLoading, isError 등)
 */
export const useCourseDetail = (courseId: number, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["course", courseId],
    queryFn: () => getCourseDetail(courseId),
    staleTime: 0, // 항상 최신 데이터 유지
    gcTime: 1000 * 60 * 10, // 10분간 가비지 컬렉션 유예
    enabled: options?.enabled !== undefined ? options.enabled : !!courseId, // courseId가 있을 때만 쿼리 실행
  });
};

